import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJHairColorList from '../view/FJHairColorList.jsx';
import FJActionHairstyleChanger from '../../../../redux/action/FJActionHairstyleChanger.js';

function FJHairColorListContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const hairColor = useSelector(state => state.hairstyleChanger.hairInfo.hairColor);

    const handleSelectHairColor = useCallback(
        color => {
            dispatch(FJActionHairstyleChanger.setHairColorAction(color));
        },
        [dispatch],
    );

    return <FJHairColorList value={hairColor} onChange={handleSelectHairColor} />;
}

export default FJHairColorListContainer;
